import { SubMenu } from '@artprov/design-system';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ROUTES, SECTIONS } from '../constants.js';

/**
 * SubMenu para navegar entre las secciones de Matching.
 * Solo se muestra cuando el usuario tiene el rol sge_view_all.
 */
export function MatchingSubMenu({ currentPath }) {
    const navigate = useNavigate();

    const items = [SECTIONS.BANCARIO, SECTIONS.JUDICIAL];

    const selected = currentPath.includes(ROUTES.JUDICIAL)
        ? SECTIONS.JUDICIAL
        : SECTIONS.BANCARIO;

    const handleClick = (item) => {
        if (item === SECTIONS.BANCARIO) {
            navigate(ROUTES.BANCARIO);
        } else {
            navigate(ROUTES.JUDICIAL);
        }
    };

    return (
        <SubMenu
            submenuItems={items}
            selected={selected}
            onClick={handleClick}
            classNameContainerFlex="justify-start"
        />
    );
}

MatchingSubMenu.propTypes = {
    currentPath: PropTypes.string.isRequired,
};
